import { c as _c } from "react/compiler-runtime";
import { cn } from "@/utils/cn";
export const baseInputClasses = cn("w-full h-[60px] md:h-[68px] lg:h-[72px] text-base font-medium text-foreground bg-background", "rounded-t-xl rounded-b-none md:rounded-r-none md:rounded-l-xl border-2 border-r-2 md:border-r-0 px-2", "focus-within:outline-none focus-within:ring-0", "[&>input]:border-0 [&>input]:outline-none [&>input]:ring-0", "[&>input]:focus:border-0 [&>input]:focus:outline-none [&>input]:focus:ring-0", "transition-colors duration-1000 ease-in-out");
export function InputSkeleton() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = cn(baseInputClasses, "border-primary focus-within:border-primary");
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className={t0}><input type="text" placeholder="Search Locality / Project name" className="w-full h-full px-1 py-2 pr-10 bg-background text-foreground rounded focus:outline-none" style={{
        boxShadow: "none"
      }} aria-label="Search property by Locality or Project name" disabled={true} /></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}